import React from "react";
import MapPage from "../MapPage";
import { Paper } from "@mantine/core";

const Client = () => {
  return (
    <Paper
      className="flex-1"
      style={{
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
        height: 'calc(100vh - 110px)',
        background:
          "transparent linear-gradient(118deg, #FFFFFF 0%, #F0F7FF 43%, #DFE8F4 78%, #C2DBFA 100%) 0% 0% no-repeat padding-box",
      }}
    >
      <MapPage />
    </Paper>
  );
};

export default Client;


